import * as React from 'react'
import Link from 'next/link'

import { cn } from '@/shared/lib/cn'
import { sanitizeHtml } from '@/shared/lib/html'
import { NextImage } from '@/shared/lib/next'
import { Button_Modern } from '@/shared/ui/button_modern'

interface BlogHomePage {
  title?: string | null
  text?: string | null
  image?: string | null
  cta?: string | null
  ctaUrl?: string | null
}

interface HomeBlogPostProps {
  data: BlogHomePage
  className?: string
}

export const HomeBlogPost: React.FC<HomeBlogPostProps> = ({ className, data }) => {
  const { title, text, image, cta, ctaUrl } = data

  const getHref = (url: string) => {
    const trimmed = url.trim()
    return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
  }

  const normalizedHref = ctaUrl ? getHref(ctaUrl) : ''

  return (
    <section className={className}>
      <div className="mx-auto max-w-[1080px] px-4">
        {title && <h2 className="mb-8 text-h1m font-semibold text-neutral desktop:mb-10 desktop:text-h1">{title}</h2>}

        <div className="grid rounded-6 bg-white desktop:grid-cols-2 desktop:items-center">
          {image && (
            <div className="relative aspect-[5/2] overflow-hidden rounded-6 desktop:order-1">
              <NextImage src={image} alt={title || ''} fill className="object-cover" />
            </div>
          )}

          <div className={cn('p-4 desktop:order-2 desktop:px-6', !image && 'desktop:col-span-2')}>
            {text && (
              <div
                className="mb-4 text-lg text-neutral desktop:mb-3"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }}
              />
            )}

            {cta && (
              <Link href={normalizedHref}>
                <Button_Modern variant="secondary" className="w-full">
                  {cta}
                </Button_Modern>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}
